import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ConsumedProductsService {

  private DASHBOARD_URL = BASE_URL.URL;

  constructor(
    private http: HttpClient, 
    private spinnerService: NgxSpinnerService, 
    private route: Router) { 
  }

  getStockId(storeId: string): Observable<any> {
    this.spinnerService.show();
    const token = localStorage.getItem('token');
    return this.http.get<any>(`${this.DASHBOARD_URL}/charts/${storeId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).pipe(
      tap(err => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }

  getChartData(storeId: string): Observable<any> {
    this.spinnerService.show();
    const token = localStorage.getItem('token');
    return this.http.get(`${this.DASHBOARD_URL}/charts/stores/${storeId}/consumed/products`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).pipe(
      tap(err => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else{
      this.spinnerService.hide();
      return throwError(()=> error);
    }
  } 
}
